import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from 'antd';
import LayoutHeader from '../layouts/header/auth_new';
import AuthLeftNav from '../components/sidebar/left';
import './authLayout.css';

const { Sider, Content } = Layout;

const AuthLayout = ({ children }) => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={240} style={{ background: '#ffffff', overflow: 'hidden' }}>
        <div className="sidebar-fallback">
          <AuthLeftNav />
        </div>
      </Sider>

      <Layout>
        <LayoutHeader />

        <Content style={{ padding: '32px', background: '#f9f9fb' }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  side: PropTypes.node.isRequired,
};

export default AuthLayout;